import React from "react";
import "../assets/css/about.css";
import founder from "../assets/images/founderimage02.png";

import { ReactTitle } from "react-meta-tags";
import Cards from "../Components/Cards";
import valuelist from "../Components/valuelist";
import { motion } from "framer-motion";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

const imgstyles = {
  borderRadius: "35px 35px 35px 35px",
  width: "80%",
  height: "auto",
  boxShadow:
    "rgba(232,189,13, 0.4) 5px 5px, rgba(232,189,13, 0.3) 10px 10px, rgba(232,189,13, 0.2) 15px 15px, rgba(232,189,13, 0.1) 20px 20px, rgba(232,189,13, 0.05) 25px 25px",
};

const containerVariants = {
  exit: {
    x: "-100vw",
    transition: {
      ease: "easeInOut",
      duration: 0.5,
    },
  },
};

const About = () => {
  return (
    <motion.div
      id="about"
      className="container pt-1 pt-md-3"
      variants={containerVariants}
      exit="exit"
    >
      <ReactTitle title="Vibgyor Advisors - About" />
      <Fade>
        <div
          id="welcome"
          className="col-12 welcome p-lg-5 pt-1 pt-md-1  my-5  p-sm-2 "
          style={{ minHeight: "90vh" }}
        >
          <h1 className="text-center text-uppercase text-warning col-12 mt-md-5 mt-3 mb-md-5 m-3 mx-auto  w-75">
            Welcome to Vibgyor Advisors
          </h1>
          <p
            className=" lead my-5 w-100 p-3 mx-auto"
            style={{ textAlign: "justify", textJustify: "inter-word" }}
          >
            Vibgyor Advisors is a first generation firm focusing on financial
            services. It works across various segments of the financial services
            and provides a wide range of services to its esteemed clients. It
            advises individuals as well as corporates on their various
            requirements with a client centric approach.
          </p>
          <div
            className="scroll d-md-none d-block mx-auto"
            style={{ width: "fit-content", margin: "4em" }}
          >
            <svg
              width="65"
              height="80"
              style={{ margin: "0 auto" }}
              viewBox="0 0 79 141"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="6.22875"
                y="3.78677"
                width="68.2282"
                height="131.646"
                rx="34.1141"
                transform="rotate(0.771761 6.22875 3.78677)"
                stroke="#FEC007"
                stroke-width="8.39412"
                stroke-linejoin="round"
              />
              <motion.circle
                initial={{ y: -10 }}
                animate={{ y: 40 }}
                transition={{ yoyo: Infinity, delay: 2, duration: 1 }}
                cx="39"
                cy="51"
                r="19"
                fill="#FEC007"
              />
            </svg>
          </div>
        </div>
      </Fade>
      <Fade bottom>
        <div
          id="founder"
          className="row my-5 m-1  p-lg-5 p-3 p-md-2 "
          style={{ background: "#02223D" }}
        >
          <h1
            className="text-center text-uppercase text-warning mt-5 w-75 "
            style={{
              display: "block",
              borderBottom: "1px solid red",
              width: "50%",
              margin: "0 auto",
            }}
          >
            About Founder
          </h1>
          <div className="container  my-5 ">
            <div className="row text-center  ">
              <div
                className="col-xs-12 mx-md-4 col-md-5 my-auto "
                style={{ textAlign: "justify", textJustify: "inter-word" }}
              >
                <p>
                  Founded by Mr. Sachin Neema who is a management graduate from
                  JBIMS, Mumbai and a mechanical engineer from VJTI, Mumbai.
                  With 22 years of experience in equity markets and having
                  worked as Analyst, Head of Research and Fund Manager, he has
                  been instrumental in running business segments for some of the
                  leading companies in the industry like HDFC Sec, IIFL and
                  Tata.
                </p>
              </div>
              <div className="col-xs-12 mx-md-3 col-md-5">
                <figure>
                  <img src={founder} width="80%" />
                  <figcaption>
                    Mr. Sachin Neema <br /> Founder & Director{" "}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </Fade>
      <Slide bottom>
        <div className="row my-5 text-small p-lg-5 p-2 p-md-2 ">
          <h1
            className="text-center text-uppercase text-warning mt-5 w-75 "
            style={{
              display: "block",
              borderBottom: "1px solid red",
              width: "50%",
              margin: "0 auto",
            }}
          >
            Our Values
          </h1>

          <div className="row d-flex flex-md-row flex-sm-column text-center mt-4 m-1 mb-4 justify-content-center">
            {valuelist.map((item) => (
              <Cards
                title={item.value}
                image={item.image}
                desc={item.content}
              />
            ))}
          </div>
        </div>
      </Slide>
    </motion.div>
  );
};

export default About;
